"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.riskResultSchema = void 0;
exports.riskResultSchema = {
    type: ['object', 'null'],
    required: [
        'cmhcAccountNumber',
        'accountStatusTypeCode',
        'currentPriceIndexValueAmount',
        'electronicPortfolioInsuranceProcessingProductScore',
        'initialPriceIndexValueAmount',
        'lenderModelPoints',
        'lenderModelRatingTypeCode',
        'marketConditionTypeCode',
        'marketModelExceptionIndicator',
        'marketModelPoints',
        'marketModelRatingTypeCode',
        'priceIndexModelPoints',
        'priceIndexModelRatingTypeCode',
        'recordCreatedTimestamp',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
        'reevaluatedLendingValueAmount',
        'reevaluatedLoanValuePercent',
        'scorecardDwellingTypeCodePoints',
        'scorecardInterestRatePoints',
        'scorecardLoanToValueRatio1',
        'scorecardLoanToValueRatio2',
        'scorecardMarketValuePoints',
        'scorecardModelDependentPoints',
        'scorecardModelRatingTypeCode',
        'scorecardPercentLoanUnpaidAmount',
        'scorecardRemainingAmortizationPeriod',
        'scorecardUrbanRuralPoints',
    ],
    properties: {
        cmhcAccountNumber: {
            type: 'number',
            maximum: 999999999999,
            minimum: 0,
            errorMessage: 'should be a number with up to 12 digits in total',
        },
        accountStatusTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        currentPriceIndexValueAmount: {
            type: 'number',
            maximum: 9999,
            minimum: -9999,
            decimal: [6, 2],
            errorMessage: 'should be a decimal with up to 6 digits in total and 2 digits of precision',
        },
        electronicPortfolioInsuranceProcessingProductScore: {
            type: 'integer',
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        initialPriceIndexValueAmount: {
            type: 'number',
            maximum: 9999,
            minimum: -9999,
            decimal: [6, 2],
            errorMessage: 'should be a decimal with up to 6 digits in total and 2 digits of precision',
        },
        lenderModelPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be an integer between 0 and 999',
        },
        lenderModelRatingTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        marketConditionTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        marketModelExceptionIndicator: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        marketModelPoints: {
            type: 'integer',
            minimum: 0,
            maximum: 999,
            errorMessage: 'should be an integer between 0 and 999',
        },
        marketModelRatingTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        priceIndexModelPoints: {
            type: 'integer',
            minimum: 0,
            maximum: 999,
            errorMessage: 'should be an integer between 0 and 999',
        },
        priceIndexModelRatingTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
        },
        reevaluatedLendingValueAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and up to 2 digits of precision',
        },
        reevaluatedLoanValuePercent: {
            type: 'number',
            errorMessage: 'should be a number',
        },
        scorecardDwellingTypeCodePoints: {
            type: 'integer',
            minimum: 0,
            maximum: 999,
            errorMessage: 'should be an integer between 0 and 999',
        },
        scorecardInterestRatePoints: {
            type: 'integer',
            minimum: 0,
            maximum: 999,
            errorMessage: 'should be an integer between 0 and 999',
        },
        scorecardLoanToValueRatio1: {
            type: 'integer',
            minimum: 0,
            maximum: 999,
            errorMessage: 'should be an integer between 0 and 999',
        },
        scorecardLoanToValueRatio2: {
            type: 'integer',
            minimum: 0,
            maximum: 999,
            errorMessage: 'should be an integer between 0 and 999',
        },
        scorecardMarketValuePoints: {
            type: 'integer',
            minimum: 0,
            maximum: 999,
            errorMessage: 'should be an integer between 0 and 999',
        },
        scorecardModelDependentPoints: {
            type: 'integer',
            minimum: 0,
            maximum: 999,
            errorMessage: 'should be an integer between 0 and 999',
        },
        scorecardModelRatingTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        scorecardPercentLoanUnpaidAmount: {
            type: 'integer',
            minimum: 0,
            maximum: 999,
            errorMessage: 'should be an integer between 0 and 999',
        },
        scorecardRemainingAmortizationPeriod: {
            type: 'integer',
            minimum: 0,
            maximum: 999,
            errorMessage: 'should be an integer between 0 and 999',
        },
        scorecardUrbanRuralPoints: {
            type: 'integer',
            minimum: 0,
            maximum: 999,
            errorMessage: 'should be an integer between 0 and 999',
        },
    },
};
exports.default = exports.riskResultSchema;
